import { render, staticRenderFns } from "./PrinterImage.vue?vue&type=template&id=362a23e4&scoped=true"
import script from "./PrinterImage.vue?vue&type=script&lang=js"
export * from "./PrinterImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362a23e4",
  null
  
)

export default component.exports